import React from 'react'
import { DeleteRounded } from '@mui/icons-material'
import { Box, IconButton } from '@mui/material'
import DraftJSPageBlock from './components/draftjs-page-block'
import { PAGE_BLOCK_TYPES } from '../../utils/page-block-types'
import { Controller } from 'react-hook-form'
import CommitmentPageBlock from './components/commitment-page-block'
import CommitmentCheckPageBlock from './components/commitment-check-page-block'
import TinyMCEPageBlock from './components/tinymce-page-block'
import { useSelector } from 'react-redux'
import { SkillBiteEditSlice } from '../../../../../reducers'

const BlockComponent = ({ block, onChange, name, index }) => {
  if (block.type === PAGE_BLOCK_TYPES.DRAFTJS) {
    return <DraftJSPageBlock block={block} onChange={onChange} />
  }

  if (block.type === PAGE_BLOCK_TYPES.COMMITMENT) {
    return <CommitmentPageBlock block={block} index={index} name={name} onChange={onChange} />
  }

  if (block.type === PAGE_BLOCK_TYPES.COMMITMENT_CHECK) {
    return <CommitmentCheckPageBlock block={block} index={index} name={name} onChange={onChange} />
  }

  if (block.type === PAGE_BLOCK_TYPES.TINYMCE) {
    return <TinyMCEPageBlock block={block} onChange={onChange} index={index} />
  }

  return (
    <div>
      <p>Block id: {block.id}</p>
      <p>Block type: {block.type}</p>
      <p>Block order: {block.order}</p>
      <p>Block index: {index}</p>
    </div>
  )
}

const PageBlock = ({ block, control, index, onDelete }) => {
  const canEditStructure = useSelector(SkillBiteEditSlice.selectors.selectCanEditStructure)
  return (
    <Box
      data-test={`page-block-${block.id}`}
      sx={{
        position: 'relative',
        marginBottom: '16px'
      }}
    >
      {canEditStructure && (
        <IconButton
          size='small'
          color='error'
          sx={{ position: 'absolute', top: 0, right: 0, zIndex: 3 }}
          onClick={() => onDelete({ blockId: block.id, index })}
          data-test={`page-block-${block.id}-delete-btn`}
        >
          <DeleteRounded fontSize='inherit' color='inherit' />
        </IconButton>
      )}
      <Controller
        control={control}
        name={`blocks.${index}.data`}
        render={({ field }) => {
          return (
            <BlockComponent
              block={block}
              index={index}
              {...field}
            />
          )
        }}
      />
    </Box>
  )
}

export default PageBlock
